import { TickIcon } from "components/common/Icons/TickIcon";
import type { TextBox } from "store/features/memeGenerator/types";

interface SelectedFontProps {
    fontFamily: TextBox["fontFamily"];
}

export const SelectedFont = ({ fontFamily }: SelectedFontProps) => {
    return (
        <div className="px-4 flex items-center justify-between text-sm pb-2 text-irBlue-200 dark:text-darkPrimary-100 font-semibold">
            <div className="overflow-hidden text-ellipsis whitespace-nowrap">{fontFamily}</div>
            <div>
                <TickIcon width={14} height={14} fill={"var(--blue)"} />
            </div>
        </div>
    );
};
